import React, { useEffect } from 'react'

import { Loader } from '@pb/components'
import { urlHasParam, getUrlParam } from '@pb/utils'
import { compose } from 'ramda'
import { useSelector, useDispatch } from 'react-redux'

import { SELECTED_INVOICE_PARAM } from '../../constants'
import { FILTER_NAME } from '../../duck/constants'
import { operationExpandInvoiceWithQuery } from '../../duck/operations'
import selectors from '../../duck/selectors'
import EmptyState from '../EmptyState'
import FailedOrdersNotice from '../FailedOrdersNotice'
import GetStartedMessage from '../GetStartedMessage'
import MonthlyInvoiceList from '../MonthlyInvoiceList'
import OrderList from '../OrderList'

interface AllPurchasesProps {
  runKlarnaOp: any
}

const AllPurchases: React.FC<AllPurchasesProps> = ({ runKlarnaOp }) => {
  const dispatch = useDispatch()
  const isKlarnaAuthenticated = useSelector(selectors.getIsKlarnaAuthenticated)
  const orderIds = useSelector((state) => selectors.getIdsForOrderFilter(FILTER_NAME.ALL, state))
  const monthlyInvoiceIds = useSelector((state) =>
    selectors.getMonthlyInvoiceIdsForFilter(FILTER_NAME.ALL, state),
  )
  const shouldShowLoadMoreOrdersButton = useSelector((state) =>
    selectors.getShouldShowLoadMoreForOrderFilter(FILTER_NAME.ALL, state),
  )
  const shouldShowLoadMoreMonthlyInvoicesButton = useSelector(
    selectors.getMonthlyInvoicesShouldShowLoadMoreButton,
  )
  const ordersHasLoaded = useSelector((state) =>
    selectors.getHasLoadedForOrderFilter(FILTER_NAME.ALL, state),
  )
  const hasMonthly = !!useSelector(selectors.getMonthlySubscription)
  const monthlyInvoicesHasLoaded = useSelector(selectors.getMonthlyInvoicesHasLoaded)
  const isLoading = !ordersHasLoaded || (hasMonthly && !monthlyInvoicesHasLoaded)
  const hasOrdersFailed = useSelector((state) =>
    selectors.getErrorForOrderFilter(FILTER_NAME.TO_DO, state),
  )

  const expandInvoiceWithQuery = (invoiceId: string): void => {
    dispatch(operationExpandInvoiceWithQuery(invoiceId, FILTER_NAME.ALL))
  }

  useEffect(() => {
    if (!isLoading && urlHasParam(SELECTED_INVOICE_PARAM)) {
      ;(compose(expandInvoiceWithQuery, getUrlParam) as (p: string) => void)(SELECTED_INVOICE_PARAM)
    }
  }, [isLoading])

  const renderAvailableOrders = (): any => (
    <OrderList
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ orderIds: any; filterName: string; runKlar... Remove this comment to see the full error message
      orderIds={orderIds}
      filterName={FILTER_NAME.ALL}
      runKlarnaOp={runKlarnaOp}
      shouldShowLoadMoreButton={shouldShowLoadMoreOrdersButton}
    />
  )

  const renderContent = (): any => {
    if (!isKlarnaAuthenticated) return <GetStartedMessage />
    if (hasOrdersFailed) return <FailedOrdersNotice />

    return isLoading ? (
      <Loader />
    ) : (
      <>
        {monthlyInvoiceIds && monthlyInvoiceIds.length > 0 && (
          <MonthlyInvoiceList
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ invoiceIds: any; shouldShowLoadMoreButton:... Remove this comment to see the full error message
            invoiceIds={monthlyInvoiceIds}
            shouldShowLoadMoreButton={shouldShowLoadMoreMonthlyInvoicesButton}
            filterName={FILTER_NAME.ALL}
          />
        )}
        {orderIds && orderIds.length ? renderAvailableOrders() : <EmptyState />}
      </>
    )
  }
  return renderContent()
}

export default AllPurchases
